/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

import PackageDetails from "./PackageDetails";
import { useNavigate } from "react-router-dom";
import CreateDiscountModal from "./CreateDiscountModal";
import CopyIcon from "../../assets/icons/copy_icon.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateShareDiscountModal from "./CreateShareDiscount";
import CopyToClipboard from "react-copy-to-clipboard";
import { enqueueSnackbar } from "notistack";
import EditDiscountModal from "./EditDiscountModel";
import { useMenuGetHtmlFromState } from "src/hooks/useMenuGetHtmlFromState";
import ImageDisplay from "src/components/ImageDisplay";
import AffiliateLinks from "./AffiliateLinks";
import useModalControl from "src/hooks/useModalControl";
import { truncateText } from "src/functions";
import CustomMenus from "src/components/CustomMenus";
import useMenu from "src/hooks/useMenu";
import { useAuthContext } from "src/auth/useAuthContext";
import eventsDiscountData from "src/services/events/getDiscounts";

const EventDescription = ({ eventData, setEventData, handle }) => {
  const { user, logout } = useAuthContext()
  const [init, setInit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const contentRef = useRef();
  const navigate = useNavigate();

  const { menuhtml: html, MenuAuxEditor: AuxEditor } = useMenuGetHtmlFromState(
    eventData?.terms_and_conditions
  );

  useEffect(() => {
    if (contentRef.current) {
      setInit(true);
      contentRef.current.innerHTML = html;
    }

  }, [html]);
  const renderHTML = (htmlContent) => {
    // Modify the rendered HTML content to apply styles to ul and ol elements
    const modifiedHtml = htmlContent?.replace(
      /<ul/g,
      '<ul style="margin-left: 35px;"'
    );
    const finalHtml = modifiedHtml?.replace(
      /<ol/g,
      '<ol style="margin-left: 20px;"'
    );
    return { __html: finalHtml };
  };

  const {
    open: discountOpen,
    handleCloseModal,
    handleOpenModal,
  } = useModalControl();

  const {
    open: discountEditOpen,
    handleCloseModal: handleEditCloseModel,
    handleOpenModal: handleEditOpenModel,
  } = useModalControl();

  const {
    open: shareDiscountOpen,
    handleCloseModal: handleShareCloseModal,
    handleOpenModal: handleShareOpenModal,
  } = useModalControl();
  const { open: anchorElOpen, anchorEl, handleClick, handleClose } = useMenu();
  const [selectDiscount, setSelectDiscount] = useState("");
  const hideContent = !eventData?.parent_event
  const [discountData, setDiscountData] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      const response = await eventsDiscountData(user, eventData?._id, logout)
      setDiscountData(response || [])
    }
    if (eventData?._id) {
      fetchData()
    }
  }, [eventData])


  return (
    <>
      <Grid
        container
        spacing={{ xs: 1, md: 2 }}
        display="flex"
        flexDirection={{ xs: "column-reverse", sm: "row" }}
      >
        <Grid item xs={12} sm={6} lg={6}>
          <Paper
            elevation={2}
            pb={2}
            sx={{ border: " 1px solid rgba(201, 201, 201, 0.50)" }}
          >
            <Box
              sx={{
                borderRadius: "0.5rem",
                height: "100%",
                overflowY: "scroll",
                padding: "1rem",
                "&::-webkit-scrollbar": {
                  width: "0px",
                },
              }}
            >
              <Stack sx={{ borderBottom: "1px solid #E4E5E7", p: 0.4 }}>
                <Typography variant="h5">Description</Typography>
              </Stack>
              <Stack
                spacing={0.5}
                sx={{
                  maxHeight: "14.375rem",
                  color: "white",
                  overflow: "scroll",
                  "&::-webkit-scrollbar": {
                    width: "2px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "main.primary",
                  },
                  mt: "1rem",
                  pr: "0.75rem",
                  overflowX: "hidden",
                }}
              >
                <Typography color="black" variant="caption" sx={{ color: "white" }}>
                  <div>
                    <div
                      dangerouslySetInnerHTML={renderHTML(
                        eventData?.description
                      )}
                    />
                  </div>
                </Typography>
              </Stack>
            </Box>
          </Paper>
          <Grid container spacing={2} sx={{ pt: 2 }}>
            <Grid item sm={12} xs={12} lg={12}>
              <Paper elevation={2}>
                {eventData?.terms_and_conditions &&
                  eventData?.terms_and_conditions?.length > 0 &&
                  JSON.parse(eventData?.terms_and_conditions)?.root?.children[0]
                    ?.children?.length !== 0 && (
                    <Box
                      sx={{
                        borderRadius: "0.5rem",
                        border: " 1px solid rgba(201, 201, 201, 0.50)",
                        overflowY: "scroll",
                        padding: "1rem",
                        "&::-webkit-scrollbar": {
                          width: "0px",
                        },
                      }}
                    >
                      <Stack sx={{ borderBottom: "1px solid #E4E5E7", p: 0.4 }}>
                        <Typography variant="h5">
                          Terms and Conditions
                        </Typography>
                      </Stack>
                      {init && <AuxEditor />}
                      <Box
                        sx={{
                          maxHeight: "14.375rem",
                          color: "white",
                          "& ul": { pl: 3 },
                          "& ol": { pl: 3 },
                          overflow: "scroll",
                          "&::-webkit-scrollbar": {
                            width: "2px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "main.primary",
                          },
                          mt: "1rem",
                          pr: "0.75rem",
                          overflowX: "hidden",
                        }}
                        ref={contentRef}
                        color="black"
                        variant="caption"
                      ></Box>
                    </Box>
                  )}
              </Paper>
            </Grid>
            <Grid item sm={12} xs={12} lg={12}>
              <Stack spacing={1}>
                <Paper
                  sx={{
                    borderRadius: "0.5rem",
                    border: " 1px solid rgba(201, 201, 201, 0.50)",
                  }}
                >
                  <Stack spacing={1} p={2}>
                    <Stack sx={{ borderBottom: "1px solid #E4E5E7" }}>
                      <Typography variant="h5">Date & Time</Typography>
                    </Stack>
                    <Stack direction={{ md: "row", xs: "column" }} spacing={3}>
                      <Stack spacing={1}>
                        <Typography variant="h5">Event Validity</Typography>
                        <Typography variant="caption">
                          {`Start: ${dayjs(eventData?.event_start).format(
                            "DD/MM/YYYY LT"
                          )}`}
                          <br />
                          {`End: ${dayjs(eventData?.event_end).format(
                            "DD/MM/YYYY LT"
                          )}`}
                        </Typography>
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant="h5">Event Distribution</Typography>
                        <Typography variant="caption">
                          {`Start: ${dayjs(
                            eventData?.distribution_start
                          ).format("DD/MM/YYYY LT")}`}{" "}
                          <br />
                          {`End: ${dayjs(eventData?.distribution_end).format(
                            "DD/MM/YYYY LT"
                          )}`}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Paper>
              </Stack>
            </Grid>

            <Grid item sm={12} xs={12} lg={12}>
              <Paper elevation={2}>
                <Stack
                  sx={{
                    p: 2,
                    border: " 1px solid #E4E5E7",
                    borderRadius: "0.5rem",
                  }}
                >
                  <Stack sx={{ p: 0.4 }} spacing={1.5}>
                    <Stack
                      direction="row"
                      sx={{
                        justifyContent: "space-between",
                        borderBottom: "1px solid #E4E5E7",
                        pb: 0.7,
                      }}
                    >
                      <Typography variant="h5">Packages</Typography>
                    </Stack>
                    {eventData?.package_data?.length > 0 && (
                      <PackageDetails eventData={eventData} />
                    )}
                  </Stack>
                </Stack>
              </Paper>
            </Grid>
            {eventData?.event_type?.name === "Public" &&
              eventData?.package_data?.length > 0 && (
                hideContent && <Grid item sm={12} xs={12} lg={12}>
                  <Paper elevation={2}>
                    <AffiliateLinks
                      eventData={eventData}
                      setEventData={setEventData}
                      handle={handle}
                    />
                  </Paper>
                </Grid>
              )}

            {eventData?.event_type?.name === "Public" &&
              (eventData?.package_data?.length ? (
                hideContent && <Grid item sm={12} xs={12} lg={12}>
                  <Paper elevation={2}>
                    <Stack
                      sx={{
                        p: 2,
                        border: " 1px solid #E4E5E7",
                        borderRadius: "0.5rem",
                      }}
                    >
                      <Stack sx={{ p: 0.4 }} spacing={1.5}>
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "space-between",
                            borderBottom: "1px solid #E4E5E7",
                            pb: 0.7,
                          }}
                        >
                          <Typography variant="h5">Event Discounts</Typography>
                        </Stack>
                        <Box
                          sx={{
                            maxHeight: "400px",
                            overflow: "auto",
                          }}
                        >
                          {discountData && discountData?.map((item, index) => {
                            return (
                              <Paper
                                key={item?._id}
                                elevation={2}
                                sx={{
                                  border: "1px solid #E4E5E7",
                                  p: " 7px 10px 15px 10px",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography variant="h5" color={"primary"}>
                                    {item?.name}
                                  </Typography>
                                  <Stack
                                    direction="row"
                                    gap="10px"
                                    alignItems="center"
                                  >
                                    <Typography
                                      variant="h5"
                                      sx={{
                                        fontSize: { xs: "12px", lg: "16px" },
                                      }}
                                    >
                                      {truncateText(item?.coupon_handle, 15)}
                                    </Typography>
                                    <CopyToClipboard
                                      text={item?.coupon_handle}
                                      onCopy={() =>
                                        enqueueSnackbar("Copy Successfully.", {
                                          variant: "success",
                                          anchorOrigin: {
                                            vertical: "top",
                                            horizontal: "right",
                                          },
                                        })
                                      }
                                    >
                                      <Box
                                        component="img"
                                        sx={{
                                          width: "15px",
                                          cursor: "pointer",
                                        }}
                                        src={CopyIcon}
                                      />
                                    </CopyToClipboard>
                                    <IconButton
                                      onClick={(e) => {
                                        handleClick(e);
                                        setSelectDiscount(item?._id);
                                      }}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    {selectDiscount == item?._id && (
                                      <CustomMenus
                                        open={anchorElOpen}
                                        anchorEl={anchorEl}
                                        handleClose={handleClose}
                                        menuList={[
                                          {
                                            label: "Discount Details",
                                            onClick: () =>
                                              navigate(
                                                `/events/discount-details/${item?._id}`
                                              ),
                                          },
                                          {
                                            label: "Edit",
                                            onClick: () => {
                                              setSelectedItem(item?._id);
                                              handleEditOpenModel();
                                              handleClose();
                                            },
                                          },
                                        ]}
                                      />
                                    )}
                                  </Stack>
                                </Box>
                                <Typography
                                  variant="h5"
                                  marginBottom="10px"
                                  sx={{ fontSize: { xs: "14px", lg: "16px" } }}
                                >
                                  Discount Usages
                                </Typography>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    border: "1px solid #E4E5E7",
                                    p: "15px 10px",
                                  }}
                                >
                                  <Grid container spacing={1}>
                                    <Grid item xs={4} md={4}>
                                      <Stack spacing={1}>
                                        <Typography
                                          variant="h5"
                                          sx={{
                                            fontSize: {
                                              xs: "12px",
                                              lg: "16px",
                                            },
                                          }}
                                        >
                                          Total Tickets
                                        </Typography>
                                        <Typography
                                          color="primary"
                                          variant="h3"
                                          sx={{
                                            fontSize: {
                                              xs: "20px",
                                              lg: "24px",
                                            },
                                          }}
                                        >
                                          {item?.tickets?.length}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                      <Stack textAlign="center" spacing={1}>
                                        <Typography
                                          variant="h5"
                                          sx={{
                                            fontSize: {
                                              xs: "12px",
                                              lg: "16px",
                                            },
                                          }}
                                        >
                                          Tickets Value
                                        </Typography>
                                        <Typography
                                          color="primary"
                                          variant="h3"
                                          sx={{
                                            fontSize: {
                                              xs: "20px",
                                              lg: "24px",
                                            },
                                          }}
                                        >
                                          {item?.total_tickets_amt}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                      <Stack textAlign="end" spacing={1}>
                                        <Typography
                                          variant="h5"
                                          sx={{
                                            fontSize: {
                                              xs: "12px",
                                              lg: "16px",
                                            },
                                          }}
                                        >
                                          Discount Applied
                                        </Typography>
                                        <Typography
                                          color="primary"
                                          variant="h3"
                                          sx={{
                                            fontSize: {
                                              xs: "20px",
                                              lg: "24px",
                                            },
                                          }}
                                        >
                                          {item?.total_discount_amt}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Paper>
                            );
                          })}
                        </Box>
                        {discountOpen && (
                          <CreateDiscountModal
                            open={discountOpen}
                            close={handleCloseModal}
                            eventData={eventData}
                            setDiscountData={setDiscountData}
                          />
                        )}
                        {shareDiscountOpen && (
                          <CreateShareDiscountModal
                            open={shareDiscountOpen}
                            close={handleShareCloseModal}
                            eventData={eventData}
                          />
                        )}

                        {discountEditOpen && (
                          <EditDiscountModal
                            open={discountEditOpen}
                            close={handleEditCloseModel}
                            eventData={eventData}
                            selectedItem={selectedItem}
                            setDiscountData={setDiscountData}
                          />
                        )}
                      </Stack>
                    </Stack>
                  </Paper>
                </Grid>
              ) : null)}
          </Grid>
        </Grid>
        <Grid item sm={6} xs={12} lg={6} spacing={1}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} lg={12}>
              <ImageDisplay
                imageUrl={
                  eventData?.images?.length > 0
                    ? eventData?.images[0].image_link
                    : ""
                }
              />
            </Grid>
            <Grid item sm={12} xs={12} lg={12}>
              <Paper
                sx={{
                  borderRadius: "0.5rem",
                  border: " 1px solid rgba(201, 201, 201, 0.50)",
                }}
              >
                <Stack sx={{ borderBottom: "1px solid #E4E5E7" }}>
                  <Typography variant="h5" sx={{ p: 1 }}>
                    Other Details
                  </Typography>
                </Stack>
                <Stack spacing={3} p={2}>
                  {eventData?.artist && (
                    <Stack spacing={1}>
                      <Typography variant="h5">
                        Event Host/ Performer
                      </Typography>
                      <Typography variant="caption">
                        {eventData?.artist}
                      </Typography>
                    </Stack>
                  )}
                  {eventData?.event_type?.handle === "public" && (
                    <Stack spacing={1}>
                      <Typography variant="h5">Event Tags</Typography>
                      <Typography variant="caption">
                        {eventData?.event_tags
                          ?.map((tag) => tag?.name)
                          .join(", ")}
                      </Typography>
                    </Stack>
                  )}

                  {eventData?.event_type?.handle === "public" &&
                    (eventData?.package_data?.some(
                      (data) => data?.publish_status === "online"
                    ) ||
                      eventData?.package_data?.some(
                        (data) => data?.publish_status === null
                      )) && (
                      (hideContent && !["rejected", "needs_improvement", "pending"].includes(eventData?.self_event_approval_status)) && <Stack spacing={1}>
                        <Stack direction="row" sx={{ alignItems: "center" }}>
                          <Typography variant="h5">Event Link</Typography>
                        </Stack>
                        {eventData?.package_data?.length > 0 ? (
                          <a
                            href={
                              eventData?.short_link
                                ? eventData?.short_link
                                : `${eventData?.link}`
                            }
                            target="_blank"
                            style={{ color: "main.primary" }}
                            rel="noreferrer"
                          >
                            {eventData?.short_link
                              ? eventData?.short_link
                              : eventData?.link}
                          </a>
                        ) : (
                          "Add packages to get event link"
                        )}
                      </Stack>
                    )}

                  <Stack spacing={1}>
                    <Typography variant="h5">Created</Typography>
                    <Typography variant="caption">
                      {`${eventData?.user_info?.name} (${dayjs(
                        eventData?.createdAt
                      ).format("DD/MM/YYYY LT")})`}
                    </Typography>
                  </Stack>
                  {eventData?.edited_by_name && (
                    <Stack spacing={1}>
                      <Typography variant="h5">Edited By</Typography>
                      <Typography variant="caption">
                        {`${eventData?.edited_by_name} (${dayjs(
                          eventData?.updatedAt
                        ).format("DD/MM/YYYY LT")})`}
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              </Paper>
            </Grid>
            <Grid item sm={12} xs={12} lg={12}>
              <OrganiserInfo user_info={eventData?.user_info || []} />
            </Grid>
            <Grid item sm={12} xs={12} lg={12}>
              <AdminActions admin_reviews={eventData?.admin_reviews || []} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EventDescription;




function OrganiserInfo({ user_info }) {
  if (!user_info) return null;

  const nameOrBusiness = user_info.parent?.name || user_info.name || "N/A";
  const phone = `+${user_info.country_code || ""} ${user_info.mobile || "N/A"}`;
  const email = user_info.email || "N/A";

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid #E0E0E0",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "white",
          fontWeight: 600,
          mb: 1,
        }}
      >
        Organiser Info
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Stack spacing={2}>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "white" }}
          >
            Name/ Business Name
          </Typography>
          <Typography sx={{ color: "white" }}>
            {nameOrBusiness}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "white" }}
          >
            Phone
          </Typography>
          <Typography sx={{ color: "white" }}>{phone}</Typography>
        </Box>

        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "white" }}
          >
            Email
          </Typography>
          <Typography sx={{ color: "white" }}>{email}</Typography>
        </Box>
      </Stack>
    </Paper>
  );
}


function AdminActions({ admin_reviews = [] }) {
  if (!admin_reviews?.length) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case "rejected":
        return "error.main";
      case "approved":
        return "success.main";
      case "needs_improvement":
        return "warning.main";
      default:
        return "text.primary";
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid #E0E0E0",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "white",
          fontWeight: 600,
          mb: 1,
        }}
      >
        Admin Actions (if Any)
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {admin_reviews.map((review, index) => (
        <Paper
          key={review._id}
          variant="outlined"
          sx={{
            borderRadius: 2,
            p: 2,
            mb: 2,
          }}
        >
          <Stack spacing={1.5}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: "white" }}
            >
              Attempt {index + 1}
            </Typography>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "white" }}
              >
                Reviewed by
              </Typography>
              <Typography sx={{ color: "white" }}>
                {review.reviewed_by}
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "white" }}
              >
                Action Performed
              </Typography>
              <Typography sx={{ color: getStatusColor(review.status), textTransform: "capitalize" }}>
                {review.status.replace(/_/g, " ")}
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "white" }}
              >
                Reason/ Note
              </Typography>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  p: 1.5,
                  mt: 0.5,
                  borderColor: "#E0E0E0",

                }}
              >
                <Typography sx={{ color: "white" }}>
                  {review.reason || "N/A"}
                </Typography>
              </Paper>
            </Box>
          </Stack>
        </Paper>
      ))}
    </Paper>
  );
}
